export const CARD_TYPE_SOURCE = 'CARD_TYPE_SOURCE';
export const CARD_TYPE_SINK = 'CARD_TYPE_SINK';
export const CARD_TYPE_SOURCE_DATASET = 'CARD_TYPE_SOURCE_DATASET';
export const CARD_TYPE_DERIVED_DATASET = 'CARD_TYPE_DERIVED_DATASET';
export const CARD_TYPE_AVAILABLE_DATASET = 'CARD_TYPE_AVAILABLE_DATASET';
export const CARD_TYPE_DATA_MAP = 'CARD_TYPE_DATA_MAP';
export const CARD_TYPE_CREDENTIAL = 'CARD_TYPE_CREDENTIAL';
export const CARD_TYPE_REUSABLE_TX = 'CARD_TYPE_REUSABLE_TX';
export const CARD_TYPE_API_KEY = 'CARD_TYPE_API_KEY';
export const CARD_TYPE_PROJECT = 'CARD_TYPE_PROJECT';
